import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

import TimeTrackingGridHourInput from './TimeTrackingGridHourInput';
import {
  HOUR_VIEW_KEYS,
  showRegularHours,
  showOTHours,
  showDoubleOTHours,
} from './timeTrackingGrid.constants';

const extractHours = (datum) => ({
  hours: parseFloat(datum?.hours) || 0,
  otHours: parseFloat(datum?.otHours) || 0,
  doubleOTHours: parseFloat(datum?.doubleOTHours) || 0,
});

export default function TimeTrackingGridCell({
  data,
  type,
  responding,
  onChange,
  selectedView,
}) {
  const { hours, otHours, doubleOTHours } = extractHours(data);
  const dataRef = useRef(data);
  dataRef.current = data;

  const handleChange = useCallback((field) => (value) => {
    onChange({
      ...extractHours(dataRef.current),
      [field]: value ?? 0,
    });
  }, [onChange]);

  if (type === 'equipment') {
    return (
      <TimeTrackingGridHourInput value={hours} onChange={handleChange('hours')} disabled={!responding} />
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {showRegularHours(selectedView) && (
        <TimeTrackingGridHourInput value={hours} onChange={handleChange('hours')} disabled={!responding} />
      )}
      {showOTHours(selectedView) && (
        <TimeTrackingGridHourInput value={otHours} onChange={handleChange('otHours')} disabled={!responding} />
      )}
      {showDoubleOTHours(selectedView) && (
        <TimeTrackingGridHourInput value={doubleOTHours} onChange={handleChange('doubleOTHours')} disabled={!responding} />
      )}
    </div>
  );
}

TimeTrackingGridCell.propTypes = {
  data: PropTypes.shape({
    hours: PropTypes.number,
    otHours: PropTypes.number,
    doubleOTHours: PropTypes.number,
  }),
  type: PropTypes.string,
  responding: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  selectedView: PropTypes.oneOf(HOUR_VIEW_KEYS),
};

TimeTrackingGridCell.defaultProps = {
  data: {},
  type: 'user',
  responding: false,
  selectedView: 'All',
};
